export default __webpack_public_path__ + "static/media/ALL IN LOGO MASTER 4.ef97d2de.svg";